<template>
    <svg width="32" height="26" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ active: !mute }">
        <g filter="url(#filter0_d)">
            <rect x="19.5332" y="8.60925" width="1.16494" height="9.70783" rx="0.58247" transform="rotate(-45 19.5332 8.60925)" fill="white"/>
            <rect x="20.5039" y="15.4048" width="1.16494" height="9.70783" rx="0.58247" transform="rotate(-135 20.5039 15.4048)" fill="white"/>
            <path d="M17.5709 3C15.9616 3 14.3859 3.42754 13.0072 4.23939C11.7774 4.96477 10.735 5.97358 9.97118 7.17454H6.53163C5.13371 7.17454 4 8.30825 4 9.70617V14.2938C4 15.6918 5.13371 16.8255 6.53163 16.8255H9.97118C10.735 18.0264 11.7774 19.0352 13.0072 19.7606C14.3859 20.5725 15.9616 21 17.5709 21C17.9311 21 18.2194 20.7118 18.2194 20.3515V3.64852C18.2194 3.29303 17.9311 3 17.5709 3ZM9.68775 15.5284H6.53163C5.84948 15.5284 5.29704 14.976 5.29704 14.2938V9.70617C5.29704 9.02402 5.84948 8.47158 6.53163 8.47158H9.68775V15.5284ZM16.9223 19.6789C14.4868 19.4724 12.2674 18.1033 10.9848 15.9992V8.0056C12.2674 5.90152 14.4868 4.53243 16.9223 4.32586V19.6789Z" fill="white"/>
        </g>
        <defs>
            <filter id="filter0_d" x="0" y="0" width="31.1276" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset dy="1"/>
                <feGaussianBlur stdDeviation="2"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>
</template>

<script>
    export default {
        props: ['mute'],
    }
</script>
<style scoped>
    svg.active rect {
       display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/icons/Mute.vue